import { Tooltip, Popover } from 'bootstrap'

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerElement) => new Tooltip(tooltipTriggerElement))
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popoverTriggerElement) => new Popover(popoverTriggerElement))
})
